__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-21-1787301470-stable-dev/";